import { Brain, Image, Search, ArrowRight } from 'lucide-react'
import type { AgentConfigListItem } from '../../../lib/api'
import { TeamBlock } from './TeamBlock'
import type { TeamHealth } from './types'

interface PipelineViewProps {
  agents: AgentConfigListItem[]
  teamHealth: Record<string, TeamHealth>
  onAgentSelect: (agentId: string) => void
}

const TEAM_META = [
  { key: 'strategy', label: 'Estrategia', icon: Search, description: 'Investiga el tema y contexto de mercado' },
  { key: 'content', label: 'Contenido', icon: Brain, description: 'Planifica, escribe, valida y critica' },
  { key: 'visual', label: 'Visual', icon: Image, description: 'Genera prompts de imagen de marca' },
]

function groupByTeam(agents: AgentConfigListItem[]): Record<string, AgentConfigListItem[]> {
  return agents.reduce<Record<string, AgentConfigListItem[]>>((acc, agent) => {
    const team = agent.team || 'other'
    if (!acc[team]) acc[team] = []
    acc[team].push(agent)
    return acc
  }, {})
}

export function PipelineView({ agents, teamHealth, onAgentSelect }: PipelineViewProps) {
  const grouped = groupByTeam(agents)

  return (
    <div className="flex flex-col lg:flex-row items-stretch gap-3 lg:gap-0">
      {TEAM_META.map((team, idx) => (
        <div key={team.key} className="flex flex-col lg:flex-row items-stretch flex-1 min-w-0">
          <div className="flex-1 min-w-0">
            <div className="mb-2">
              <p className="text-xs text-slate-400 px-1">
                {idx + 1}. {team.description}
              </p>
            </div>
            <TeamBlock
              teamKey={team.key}
              label={team.label}
              icon={team.icon}
              agents={grouped[team.key] ?? []}
              health={teamHealth[team.key] ?? 'idle'}
              onAgentSelect={onAgentSelect}
              defaultOpen={team.key === 'content'}
            />
          </div>
          {idx < TEAM_META.length - 1 && (
            <div className="flex items-center justify-center px-3 py-2 lg:py-0 text-slate-300">
              <ArrowRight className="w-5 h-5 hidden lg:block" />
              <div className="w-px h-4 bg-slate-300 lg:hidden" />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
